
import React, { useState, useEffect, useRef } from 'react'; 
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import landscape          from './products.module.css';
import portrait           from './portrait.module.css';
import {Context}          from '../services/context.js';
import MyCard             from '../components/MyCardV2.jsx';
import MyCardPortrait     from '../components/MyCardPortrait.js';
import {BSB_B010}         from './bsb_b010.jsx'
import {TrustIt}          from './trust_it.jsx';
import {BSB300}           from './bsb_300.jsx'
import {BSB700}           from './bsb_700.jsx';
import Container          from 'react-bootstrap/Container';

import pic_product_1 from '../pictures/Sample.avif';               // trust it
import pic_product_2 from '../pictures/PCI_express_front.avif';   // Server board
import pic_product_3 from '../pictures/BSB 300.avif'; 
import pic_product_4 from '../pictures/003.avif';

import { Helmet }           from 'react-helmet';
import cx              from 'classnames';

const cx_title  = cx({[portrait.title]:  Context.portrait, [landscape.title]:  !Context.portrait});
const cx_header = cx({[portrait.header]: Context.portrait, [landscape.header]: !Context.portrait});
const cx_text   = cx({[portrait.text]:   Context.portrait, [landscape.text]:   !Context.portrait});
const cx_ul     = cx({[portrait.ul]:     Context.portrait, [landscape.ul]:     !Context.portrait});

const title_product_1 = <p className={cx_header}> Trust.it - Your WEB app </p>;

const text_product_1  = [<p>Soon avilable on-line.
Trust.it is a public application on the Back-Step Blockchain. It keeps your data forever. It is available on your browser, first as desktop app and then a bit later for mobile devices.
</p>];

const title_product_2 = <p className={cx_header}>Back-Step Server Board</p>;
const text_product_2  = [ <p>For businesses and service providers with their own Back-Step Server. </p>];

const title_product_3 = <p className={cx_header}>BSB Business Version</p>;
const text_product_3  = [`For all bussiness applications, also ideal to replace and expand existing Cryptocurrency blockchains.`]

const title_product_4 = <p className={cx_header}>AI Currency Processor</p>;
const text_product_4  = [`In prototype state. High speed block processing for challenging applications like real time Credit Card transactions during peak times or AI transactions. 
The product realized a pass through architecture with seperate processors for raw block input and for processed blocks ready for storage.`]


//-----------------------------------------------------
//  Function code converted from class code
//-----------------------------------------------------
const Products = (props) => 
{
    //const [, forceUpdate] = useState(0);

    const [contentDisabled, setContentDisabled] = useState(false)
    const location = useLocation();
    const prevLocationState = useRef(location.state);
    const [selectedForm, setSelectedForm] = useState(0);
        
 
    //-----------------------------------------------------------    
    //
    //-----------------------------------------------------------    
    useEffect(() => 
    {
      if (prevLocationState.current !== location.state) 
      {
        if (selectedForm > 0)
        {
          setSelectedForm(0)
        }
        prevLocationState.current = location.state;
      }
      window.scrollTo({top:0, left: 0, behavious: 'smooth'});
    }, [location.state]);
 
   
  
    //-----------------------------------------------------------    
    //
    //-----------------------------------------------------------    
    const changeVisible = (mode)=>
    {
      setContentDisabled(mode)
      console.log('mode', mode)
    }


    //-----------------------------------------------------------    
    //
    //-----------------------------------------------------------    
    const detailCard = (select) =>
    {  
      console.log('card:', select)
      setSelectedForm(select)
    }  


    let mainForm = ''
    let componentToRender ='';
    
    if (Context.portrait)
    {
      mainForm = (

        <div className={portrait.backdrop}>

          <Helmet>
            <title>Overview showing many aspects of the invention</title>
            <meta name="description" content="Short description of the details explained in own pages." />
            <meta charSet="utf-8" />
          </Helmet>

          <div className={portrait.container}>

            <div className={cx_title}>Products</div>
  
            <div className={cx_text}>
              <MyCardPortrait 
                title={title_product_1}
                img={pic_product_1} 
                text={text_product_1}
                btn="See more..."
                detail={() => detailCard(1)}
              />
            </div>
            
    
            <div className={cx_text}>
              <MyCardPortrait 
                title={title_product_2}
                img={pic_product_2} 
                text={text_product_2}
                btn="See more..."
                detail={() => detailCard(2)}
              />
            </div>
    
            <div className={cx_text}>
              <MyCardPortrait 
                title={title_product_3}
                img={pic_product_3} 
                text={text_product_3}
                btn="See more..."
                detail={() => detailCard(3)}
              />
            </div>
    
            <div className={cx_text}>
              <MyCardPortrait 
                title={title_product_4}
                img={pic_product_4} 
                text={text_product_4}
                btn="See more..."
                detail={() => detailCard(4)}
              />
            </div>
          </div>
        </div>
      );

      switch (selectedForm) 
      {

          case 1:  
          componentToRender = <div><TrustIt/></div>;
          break;

          case 2:  
          componentToRender = <div><BSB_B010/></div>;  // HW PCIe board
          break;

          case 3:  
          componentToRender = <div><BSB300/></div>;
          break;

          case 4:  
          componentToRender = <div><BSB700/></div>;
          break;

          default:
          componentToRender = mainForm;
          break;
      }

    return componentToRender;

  }
  else
  {
    mainForm = (
    <div className={landscape.backdrop} onMouseDown={()=>changeVisible(true)} onMouseUp={()=>changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>
      
      <Helmet>
        <title>Product Overview</title>
        <meta name="description" content="Shows products available and under development. Each product has its own page" />
        <meta charset="utf-8" />
      </Helmet>

      { ! contentDisabled &&
      <>
          <Container className={landscape.container}>

            <MyCard 
              key ={5}
              title={title_product_1}
              img={pic_product_1} 
              text={text_product_1}
              btn="See more..."
              detail={(e) => { detailCard(1)}}
            />

            <MyCard 
              key ={6}
              title={title_product_2}
              img={pic_product_2} 
              text={text_product_2}
              btn="Read more..."
              detail={()=>detailCard(2)}>            
            </MyCard>  
        
          </Container>
 
    

          <Container className={landscape.container}>

            <MyCard 
              key ={7}
              title={title_product_3}
              img={pic_product_3} 
              text={text_product_3}
              btn="Read more..."
              detail={()=>detailCard(3)}>  
            </MyCard>  
        
            <MyCard 
              key ={8}
              title={title_product_4}
              img={pic_product_4} 
              text={text_product_4}
              btn="Read more..."
              detail={()=>detailCard(4)}>            
            </MyCard>  

          </Container>
     
        </>
       }
    </div>
    )
  }


  switch (selectedForm)
  {

    case 1:  
    componentToRender = <div><TrustIt/></div>;
    break;

    case 2:  
    componentToRender = <div><BSB_B010/></div>;  // HW PCIe board
    break;

    case 3:  
    componentToRender = <div><BSB300/></div>;
    break;

    case 4:  
    componentToRender = <div><BSB700/></div>;
    break;

    default:
      componentToRender = mainForm;
  }
  return  componentToRender ;
}

export default Products;
  